import { c as _c } from "react/compiler-runtime";
import Link from "next/link";
import { DesktopLeafLink } from "./desktop-leaf-link";
import { isNavGroup, type NavGroup, type NavLeaf } from "./navigation-data";
type DesktopGroupContentProps = {
  group: NavGroup;
  pathname: string;
};
function headingId(label: string) {
  return `desktop-${label.toLowerCase().replaceAll(" ", "-")}`;
}
export function DesktopGroupContent(t0) {
  const $ = _c(20);
  const {
    group,
    pathname
  } = t0;
  const t1 = group.children;
  let t2;
  let t3;
  let t4;
  let t5;
  if ($[0] !== group.children || $[1] !== group.href || $[2] !== group.label || $[3] !== pathname) {
    t5 = Symbol.for("react.early_return_sentinel");
    bb0: {
      const subGroups = t1.filter(isNavGroup);
      const leaves = group.children.filter(_temp);
      if (subGroups.length === 0) {
        let t6;
        if ($[8] !== group.href || $[9] !== group.label || $[10] !== pathname) {
          t6 = group.href ? <li><DesktopLeafLink item={{
              label: `Explore ${group.label}`,
              href: group.href
            }} pathname={pathname} /></li> : null;
          $[8] = group.href;
          $[9] = group.label;
          $[10] = pathname;
          $[11] = t6;
        } else {
          t6 = $[11];
        }
        let t7;
        if ($[12] !== pathname) {
          t7 = item_0 => <li key={item_0.href}><DesktopLeafLink item={item_0} pathname={pathname} /></li>;
          $[12] = pathname;
          $[13] = t7;
        } else {
          t7 = $[13];
        }
        t5 = <ul className="grid w-64 gap-1 p-1">{t6}{leaves.map(t7)}</ul>;
        break bb0;
      }
      t2 = "grid w-[760px] grid-cols-3 gap-4 p-2";
      let t6;
      if ($[14] !== pathname) {
        t6 = subGroup => {
          const id = headingId(subGroup.label);
          return <section key={subGroup.label} aria-labelledby={id}><h3 id={id} className="px-3 pt-2 pb-1 font-sans text-xs tracking-normal text-primary">{subGroup.href ? <Link className="transition-colors hover:text-foreground" href={subGroup.href}>{subGroup.label}</Link> : subGroup.label}</h3><ul className="grid gap-1">{subGroup.children.map(item_1 => isNavGroup(item_1) ? null : <li key={item_1.href}><DesktopLeafLink item={item_1} pathname={pathname} /></li>)}</ul></section>;
        };
        $[14] = pathname;
        $[15] = t6;
      } else {
        t6 = $[15];
      }
      t3 = subGroups.map(t6);
      t4 = leaves.length > 0 ? <section aria-labelledby={`${headingId(group.label)}-more`}><h3 id={`${headingId(group.label)}-more`} className="px-3 pt-2 pb-1 font-sans text-xs tracking-normal text-primary">More</h3><ul className="grid gap-1">{group.href ? <li><DesktopLeafLink item={{
              label: `All ${group.label}`,
              href: group.href
            }} pathname={pathname} /></li> : null}{leaves.map(item_2 => <li key={item_2.href}><DesktopLeafLink item={item_2} pathname={pathname} /></li>)}</ul></section> : null;
    }
    $[0] = group.children;
    $[1] = group.href;
    $[2] = group.label;
    $[3] = pathname;
    $[4] = t2;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t2 = $[4];
    t3 = $[5];
    t4 = $[6];
    t5 = $[7];
  }
  if (t5 !== Symbol.for("react.early_return_sentinel")) {
    return t5;
  }
  let t6;
  if ($[16] !== t2 || $[17] !== t3 || $[18] !== t4) {
    t6 = <div className={t2}>{t3}{t4}</div>;
    $[16] = t2;
    $[17] = t3;
    $[18] = t4;
    $[19] = t6;
  } else {
    t6 = $[19];
  }
  return t6;
}
function _temp(item) {
  return !isNavGroup(item);
}